import axios from "axios";
import { getEnvVaribles } from "../helpers/getEnvVaribles";
const {API_URL} = getEnvVaribles();
const axiosBase = axios.create({
    baseURL: API_URL,
    headers : {"Content-Type": "application/json"}, 
});
export default axiosBase;